import AppHeader from "@/components/AppHeader";

export default {
  name: "master-position-new",
  components: {
    AppHeader
  },
  created() {
    this.getCompany();
    this.position.company_id = localStorage.company_id;
  },
  data() {
    return {
      position: {
        company_id: "",
        name: "",
        priority: "",
        default_authority: ""
      },
      companies: "",
      getCompanisEnd: false,
      savingFlag: false
    };
  },
  methods: {
    async getCompany() {
      let data = {};
      let res = await this.$store
        .dispatch("GET_COMPANY", { data: data })
        .catch(err => {
          console.log(err);
          return;
        });
      this.companies = res.companies;
      this.getCompanisEnd = true;
    },
    async createPosition() {
      if (this.savingFlag) return;
      this.savingFlag = true;

      let data = this.position;
      let res = await this.$store
        .dispatch("CREATE_POSITION", { data: data })
        .catch(err => {
          console.log(err);
          return;
        });
      if (res.error) {
        this.errorInfo = res.error;
      } else {
        this.$router.push({ path: "/master_position" });
      }
    },
    goMasterPosition() {
      this.$router.push({ path: "/master_position" });
    }
  }
};
